export default __webpack_public_path__ + "message-circle.svg";